import React, { useRef, useState } from 'react';
import Rimg from './Rimg.jsx';
import CollectionProductColors from './CollectionProductColors.jsx';
import ProductBadges from './ProductBadges.jsx';
import handleize from '../utils/handleize.js';
import ReactPlaceholder from 'react-placeholder';
import { RectShape } from 'react-placeholder/lib/placeholders';

export default function ProductItem(props) {
  const colorsPerPage = props.layout === 'expanded' ? props.columnCount === "4" ? 5 : 6 : 4;
  const CollectionProductColorsPlaceholder = (
    <div className="product-colors-wrapper">
      <div className="product-colors">
        {
          Array(colorsPerPage).fill(0).map((x, i) => {
            return <RectShape key={i} className="product-color" color="#f6f6f6" style={{ height: 0, paddingBottom: `calc(${100 / colorsPerPage}% - 8px)`, marginRight: '8px' }} />
          })
        }
      </div>
    </div>
  );

  const [hover, setHover] = useState(false);
  const [height, setHeight] = useState(null);
  const [activeThumb, setActiveThumb] = useState({});
  const productRef = useRef(null);

  const title = activeThumb.title || props.title, price = activeThumb.price || props.price;
  let link = `/products/${props.handle}`;
  if (props.collectionHandle && props.collectionHandle.includes('seconds')) {
    link = `/collections/${props.collectionHandle}${link}`;
  } else if (props.collectionHandle.includes('wide')) {
    link += `?collection=${props.collectionHandle}`;
  }

  let cName = `product product-${props.id} pt-${handleize(props.type)}`;
  if (hover) {
    cName += ' product-item-hover'
  }

  const highlights = props.tags.filter(tag => tag.startsWith('highlight:')).map(tag => tag.replace('highlight:', ''));
  const titleArray = title.split('|');

  let onMouseEnter = null, onMouseLeave = null;
  if (props.isDesktop && props.thumbnails && !props.inlineThumbs) {
    onMouseEnter = () => {
      setHeight(productRef.current.offsetHeight);
      setHover(true);
    }
    onMouseLeave = () => {
      setHeight(null);
      setHover(false);
    }
  }
  
  return <li className={cName} data-product-item={props.handle} data-product-id={props.id} ref={productRef} style={{height}} role="cell">
    <div className="product-inner" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <figure className="product-card-figure">
        {props.image.src && <Rimg src={props.image.src} alt={props.image.alt || props.title} width={props.image.width} height={props.image.height} loading="lazy" />}
        {props.hoverImage.src && <Rimg src={props.hoverImage.src} alt={props.hoverImage.alt || props.title} width={props.hoverImage.width} height={props.hoverImage.height} loading="lazy" className="secondary-image" />}
        {activeThumb.image && <Rimg src={activeThumb.image.src} width={activeThumb.image.width} height={activeThumb.image.height} loading="lazy" className="color-image" />}
        <ProductBadges tags={props.tags} available={props.available} />
        <a href={link} tabIndex="-1" aria-label={props.title}></a>
      </figure>
      {props.isDesktop && hover && <CollectionProductColors layout={props.layout} colorsPerPage={colorsPerPage} thumbnails={props.thumbnails} current={props.handle} setActiveThumb={setActiveThumb} collectionHandle={props.collectionHandle} />}
      <div className="product-card-footer">
        <div className="product-card-details">
          <a href={link} aria-label={title} className="title-link">
            <h2 className="title">{titleArray[0]}</h2>
            {titleArray[1] && <h4 className="color">{titleArray[1]}</h4>}
          </a>
          {!hover && highlights.map((highlight, i) => <div className="highlight-wrapper" key={i}>
            <p className="highlight">{highlight}</p>
          </div>)}
          <p className="price">
            <span className="money price-min">{Shopify.formatMoney(price, Theme.moneyFormat)}</span>
          </p>
          {props.inlineThumbs &&
            <ReactPlaceholder customPlaceholder={CollectionProductColorsPlaceholder} ready={props.thumbnails} showLoadingAnimation={false}>
              <CollectionProductColors layout={props.layout} colorsPerPage={colorsPerPage} thumbnails={props.thumbnails} current={props.handle} setActiveThumb={setActiveThumb} collectionHandle={props.collectionHandle} />
            </ReactPlaceholder>
          }
        </div>
      </div>
    </div>
  </li>
}